"use strict";

class SuperAmlCftViewController {

    constructor($scope, $window, $filter, SSAppService, SSHttpService, SSUtilService, SSDateService, SSAlertService, $timeout, SSConfigService, SSConfirmationService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.SSAppService = SSAppService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.$timeout = $timeout;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;
        self.data = SHOWSUITE.data;
        self.filter = $filter;
        self.nationalities = self.SSConfigService.getNationalities();
        self.countries = self.SSConfigService.getCountries();
        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.GENDER_MAP=[
            {"id": 1, "value":  "Male"},
            {"id": 2, "value":  "Female"},
        ];

        $('.datepicker').datepicker({
            dateFormat: "dd/mm/yy"
        });

        self.pagination = {
            current: 1
        };

        if(self.property_id)
        {
            self.property_id = parseInt(self.property_id);
        }

        if(self.sale_status)
        {
            self.sale_status = parseInt(self.sale_status);
        }


        self.pageChanged = function(newPage) {
            self.retrieveApplications(newPage);
        };


        self.sales = [];
        self.select_property_id = "";
        self.projects = [];
        self.limit = 10;
        self.offset = 0;
        self.sales_total = 0;
        self.retrieveApplications(self.current);

    }

    editAmlCft(aml, index) {
        const self = this;
        self.currentAml = angular.copy(aml);
        self.currentAml.dob = self.SSUtilService.formatDateDMY(self.currentAml.dob);
        self.currentAml.listed_on_date = self.SSUtilService.formatDateDMY(self.currentAml.listed_on_date);
        self.index = index;
        self.hideModals();
        jQuery('#editAmlCftModal').modal('show');
    }

    deleteAmlCft(aml, index)
    {
        const self = this;
        let url = 'sec/super/aml-cft/delete';
        let params =  aml;

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            self.aml_cft.splice(index, 1);
            self.hideModals();
            self.SSAlertService.success('Success!', 'Data deleted successfully.');
        });
    }

    addAmlCft()
    {
        const self = this;
        self.hideModals();
        self.currentAml = {};
        jQuery('#addAmlCftModal').modal('show');
    }

    hideModals() {
        const self = this;
        if ($('#editAmlCftModal').is(':visible')) $('#editAmlCftModal').modal('hide');
        if ($('#addAmlCftModal').is(':visible')) $('#addAmlCftModal').modal('hide');
    }


    previousPage() {
        const self = this;

        self.offset = self.offset - parseInt(self.limit);
        self.retrieveApplications();
    }

    nextPage() {
        const self = this;

        self.offset = self.offset + parseInt(self.limit);
        self.retrieveApplications();
    }

    validateReportGenerate() {
        const self = this;

        let form_clean = true;

                if (!self.currentAml.hasOwnProperty("first_name") || self.currentAml.first_name == "" || self.currentAml.first_name == undefined) {
                    self.amlErrors.first_name = "Please enter first name";
                    form_clean = false;
                }


        return form_clean;
    }

    updateAmlCft()
    {
        const self = this;
        self.amlErrors = {};

        if (!self.validateReportGenerate())
            return;

        let url = 'sec/super/aml-cft/update';
        self.registerErrors =null;
        let aml = {
            address_id: self.currentAml.address_id ? self.currentAml.address_id: "",
            alias_name: self.currentAml.alias_name ? self.currentAml.alias_name : "",
            dob: self.currentAml.dob ? self.SSUtilService.formatDateToStore(self.currentAml.dob) : "",
            first_name: self.currentAml.first_name ? self.currentAml.first_name : "",
            gender: self.currentAml.gender ? self.currentAml.gender : "",
            id: self.currentAml.id,
            last_name: self.currentAml.last_name ? self.currentAml.last_name : "",
            listed_on_date: self.currentAml.listed_on_date ? self.SSUtilService.formatDateToStore(self.currentAml.listed_on_date) : "",
            nationality: self.currentAml.nationality ? self.currentAml.nationality : "",
            source: self.currentAml.source ? self.currentAml.source : "",
        };

        let address = {
            country: self.currentAml.address.country ? self.currentAml.address.country : "",
            line1: self.currentAml.address.line1 ? self.currentAml.address.line1 : "",
            line2: self.currentAml.address.line2 ? self.currentAml.address.line2 : "",
            unit_no: self.currentAml.address.unit_no ? self.currentAml.address.unit_no : "",
            district: self.currentAml.address.district ? self.currentAml.address.district : "",
            province: self.currentAml.address.province ? self.currentAml.address.province : "",
            city: self.currentAml.address.city ? self.currentAml.address.city : "",
            postcode: self.currentAml.address.postcode ? self.currentAml.address.postcode : "",
        };

        let params = {
            aml_cft: aml,
            address: address
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            self.aml_cft[self.index] = response.data;
            self.hideModals();
            self.SSAlertService.success('Success!', 'All data updated successfully.');
        });
    }

    saveAmlCft()
    {
        const self = this;
        self.amlErrors = {};

        if (!self.validateReportGenerate())
            return;

        let url = 'sec/super/aml-cft/create';
        self.registerErrors =null;
        let aml = {
            address_id: null,
            alias_name: self.currentAml.alias_name ? self.currentAml.alias_name : "",
            dob: self.currentAml.dob ? self.SSUtilService.formatDateToStore(self.currentAml.dob) : "",
            first_name: self.currentAml.first_name ? self.currentAml.first_name : "",
            gender: self.currentAml.gender ? self.currentAml.gender : "",
            id: self.currentAml.id,
            last_name: self.currentAml.last_name ? self.currentAml.last_name : "",
            listed_on_date: self.currentAml.listed_on_date ? self.SSUtilService.formatDateToStore(self.currentAml.listed_on_date) : "",
            nationality: self.currentAml.nationality ? self.currentAml.nationality : "",
            source: self.currentAml.source ? self.currentAml.source : "",
        };

        let address = {
            country: self.currentAml.country ? self.currentAml.country : "",
            line1: self.currentAml.line1 ? self.currentAml.line1 : "",
            line2: self.currentAml.line2 ? self.currentAml.line2 : "",
            unit_no: self.currentAml.unit_no ? self.currentAml.unit_no : "",
            district: self.currentAml.district ? self.currentAml.district : "",
            province: self.currentAml.province ? self.currentAml.province : "",
            city: self.currentAml.city ? self.currentAml.city : "",
            postcode: self.currentAml.postcode ? self.currentAml.postcode : "",
        };

        let params = {
            aml_cft: aml,
            address: address
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            if(self.aml_cft)
            {
                self.aml_cft.push(response.data);
            }
            self.hideModals();
            self.SSAlertService.success('Success!', 'All data saved successfully.');
        });
    }

    retrieveApplications(page) {
        const self = this;
        self.SSAlertService.message = null

        let status = self.sale_status;

        if (self.sale_status == "" || self.sale_status == null) {
            status = self.SALE_STATUS_VERIFIED + ',' + self.SALE_STATUS_REJECTED + ',' + self.SALE_STATUS_OTP + ',' + self.SALE_STATUS_APPROVED;
        } else if (self.sale_status == self.SALE_STATUS_APPROVED) {
            status = self.SALE_STATUS_OTP + ',' + self.SALE_STATUS_APPROVED;
        }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
        }

        if(page) {
            self.current = page;
        }

        var limit = sessionStorage.getItem("limit_filter");

        if(limit && limit!='' && limit!=null)
        {
            self.limit = limit;
        }

        let url = 'sec/super/aml-cft';
        let params = {
            'limit': self.limit,
            'offset': self.offset,
             'send_total_count': true,
            'first_name': self.filter.first_name,
            'last_name': self.filter.last_name,
            'alias_name': self.filter.alias_name,
        };

        params.order = {};
        params.order[self.sortColumn] = self.sortOrder;

        if (self.search_value) {
            params[self.search_by] = self.search_value;
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }


             self.aml_cft = response.data.aml_cft;
             self.aml_cft_total = response.data.total_count;

                jQuery.each(self.aml_cft, function (i, aml) {
                    aml.nationality = self.SSUtilService.findValueFromArray(self.nationalities, 'id', aml.nationality);
                    if(aml.alias_name)
                    {
                        aml.alias_name = aml.alias_name.replace("\n", '/');
                    }
                    if(aml.nationality)
                    {
                        aml.nationality = aml.nationality.id;
                    }
                });
        });
    }

    /**
     * Open the standalone bulk AML Scan tool.
     *
     * @remarks WEB-4607: the page is served by Web itself (public/html/aml_scan.html)
     *          and calls the API through the /_api proxy with the Web login session.
     *          It used to live on the API host, which has no browser session since
     *          WEB-3591, so it loaded blank.
     */
    openAmlScanPage() {
        window.open('/html/aml_scan.html', '_blank');
    }
}

SuperAmlCftViewController.$inject = ['$scope', '$window', '$filter', 'SSAppService', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', '$timeout', 'SSConfigService', 'SSConfirmationService', 'SSUserService'];
app.controller('SuperAmlCftViewController', SuperAmlCftViewController);

